import styled from 'styled-components';

export const Note = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ModeTabs = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const ModeTab = styled.button<{ $active: boolean }>`
  flex: 1;
  padding: ${({ theme }) => theme.spacing(2.5)} ${({ theme }) => theme.spacing(3)};
  background: transparent;
  border: none;
  border-bottom: 2px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : 'transparent')};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary : theme.colors.text.secondary};
  font: inherit;
  font-size: 13px;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  cursor: pointer;
  transition:
    color 160ms ease,
    border-color 160ms ease;
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const DirectionRadios = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const DirectionOption = styled.label<{ $active: boolean }>`
  display: block;
  padding: ${({ theme }) => theme.spacing(3)};
  border: 1px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : theme.colors.border)};
  background: ${({ theme, $active }) => ($active ? theme.colors.primarySoft : 'transparent')};
  border-radius: ${({ theme }) => theme.radius.md};
  cursor: pointer;
  font-size: 13px;
  transition:
    background 160ms ease,
    border-color 160ms ease;

  & > input {
    display: none;
  }
  & > strong {
    display: block;
    margin-bottom: 4px;
    color: ${({ theme }) => theme.colors.text.primary};
  }
  & > span {
    color: ${({ theme }) => theme.colors.text.muted};
    font-size: 12px;
    line-height: 1.4;
  }
`;

export const TopTabs = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(5)};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const TopTab = styled.button<{ $active: boolean }>`
  appearance: none;
  background: transparent;
  border: none;
  border-bottom: 2px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : 'transparent')};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.text.primary : theme.colors.text.secondary};
  padding: ${({ theme }) => theme.spacing(2.5)} ${({ theme }) => theme.spacing(4)};
  font: inherit;
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  letter-spacing: -0.005em;
  cursor: pointer;
  transition:
    color ${({ theme }) => theme.motion.fast} ${({ theme }) => theme.motion.easeOut},
    border-color ${({ theme }) => theme.motion.fast} ${({ theme }) => theme.motion.easeOut};

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
    border-radius: ${({ theme }) => theme.radius.xs};
  }
`;

// ─── Styled Components replacing inline styles ─────────────────────────

export const ClaimsBarRight = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const ClaimsResetButton = styled.button`
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  text-decoration: underline;
`;

export const ClaimClickableRow = styled.tr`
  cursor: pointer;
`;

export const ClaimEmptyDash = styled.span`
  color: ${({ theme }) => theme.colors.text.muted};
  font-size: 12px;
`;

export const ContractFieldDescription = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.muted};
  margin-top: 4px;
`;
